"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name.js");
var _react = _interopRequireWildcard(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _htmlReactParser = require("html-react-parser");
var _ndsLib = _interopRequireDefault(require("./nds-lib"));
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

var nodeToNDSComponent = function nodeToNDSComponent() {
  var componentDict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var forceWhitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (node) {
    if ((0, _isEmpty.default)(node.name)) {
      return node.data;
    }

    // Since the children have already been convereted to DOM nodes,
    // we need to use domToReact to transform them
    var childrenTransformed = !(0, _isEmpty.default)(node.children) ? (0, _htmlReactParser.domToReact)(node.children, {
      replace: nodeToNDSComponent(componentDict)
    }) : node.data;
    var nodeName = String(node.name);

    // We need to find a transformer for the node un the custom library first
    var NDSTransformer;
    if (forceWhitelist) {
      NDSTransformer = componentDict[nodeName] || componentDict.generic || _ndsLib.default.generic;
    } else {
      NDSTransformer = componentDict[nodeName] || _ndsLib.default[nodeName] || componentDict.generic || _ndsLib.default.generic;
    }
    var NDSElement = NDSTransformer(node, childrenTransformed);

    // We need to make sure the transformer returns a react element, otherwise,
    // the replace won't work
    return /*#__PURE__*/(0, _react.isValidElement)(NDSElement) ? NDSElement : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, NDSElement);
  };
};
var _default = nodeToNDSComponent;
exports.default = _default;